export default "__VITE_ASSET__D3MlnN63__"